<template>
<div>
  <template v-if="isLoad">
    <v-row style="text-align: -webkit-center;">
      <v-col>
        <v-progress-circular
          :width="3"
          color="red"
          indeterminate
        ></v-progress-circular>
      </v-col>
    </v-row>
  </template>  
  <template v-if="!isLoad & !isTrue">
    <v-row>
        <v-col>
          <v-select
            v-if="cards.length > 0"
            required
            v-model="card.guid"
            :items="cards"
            clearable
            :item-text="'Purse'"
            :item-value="'Guid'"
            label="Выбор карты"
            >
          </v-select>
        </v-col>
        <v-col v-if="card.guid">
           CVC Код
            <v-text-field
                v-model="card.CardCode"
                :error-messages="cardCodeErrors"
                @input="$v.card.CardCode.$touch()"
                @blur="$v.card.CardCode.$touch()"
                color="grey"
                required
                outlined
                label="CVC код">
            </v-text-field>
          </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="card.Phone"
          :error-messages="phoneErrors"
          @input="$v.card.Phone.$touch()"
          @blur="$v.card.Phone.$touch()"
          color="grey"
          :counter="16"
          required
          label="Номер телефона">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="card.Email"
          :error-messages="emailErrors"
          @input="$v.card.Email.$touch()"
          @blur="$v.card.Email.$touch()"
          color="grey"
          required
          label="Email">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="card-wrapper" v-if="!card.guid">
      <v-col>
        <v-row>
          <v-col>
            <v-text-field
              v-model="card.PayeePurse"
              :error-messages="payeePurseErrors"
              @input="$v.card.PayeePurse.$touch()"
              @blur="$v.card.PayeePurse.$touch()"
              color="grey"
              :counter="16"
              required
              outlined
              label="Номер карты">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="6">
            Срок действия
            <div style="display:flex">
              <v-text-field
                v-model="card.CardMonth"
                :error-messages="cardMonthErrors"
                @input="$v.card.CardMonth.$touch()"
                @blur="$v.card.CardMonth.$touch()"
                color="grey"
                required
                outlined
                label="Месяц">
              </v-text-field>
              <v-text-field
                v-model="card.CardYear"
                :error-messages="cardYearErrors"
                @input="$v.card.CardYear.$touch()"
                @blur="$v.card.CardYear.$touch()"
                color="grey"
                required
                outlined
                label="Год">
              </v-text-field>
            </div>
          </v-col>
          <v-col>
            Код
            <v-text-field
                v-model="card.CardCode"
                :error-messages="cardCodeErrors"
                @input="$v.card.CardCode.$touch()"
                @blur="$v.card.CardCode.$touch()"
                color="grey"
                required
                outlined
                label="CVC код">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="card.CardHolder"
              :error-messages="cardHolderErrors"
              @input="$v.card.CardHolder.$touch()"
              @blur="$v.card.CardHolder.$touch()"
              color="grey"
              required
              outlined
              label="Владелец карты">
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="text-align: end;">
        <button v-on:click="send()" class="red-button" style="min-width: 20%">Оплатить</button>
      </v-col>
    </v-row>
  </template>   
  <template  v-if="!isLoad & isTrue">
    <div class="wrapper-pay">
      <p class="title-pay sucsess">
        Оплата прошла успешно <br/>
      </p>
      <router-link to="/">
      <button class="red-button">
          Вернуться на главную
        </button>
      </router-link>
    </div>

  </template>
</div>    
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, email, integer} from 'vuelidate/lib/validators' 
import { mapGetters  } from "vuex";

export default {
  mixins: [validationMixin],
  validations: {
    card:{
      Phone: { required, integer, maxLength: maxLength(12) },
      Email: { required, email },
      PayeePurse: { required, integer, maxLength: maxLength(16) },
      CardHolder: { required },
      CardMonth: { required, integer, maxLength: maxLength(2) },
      CardYear: { required, integer, maxLength: maxLength(4) },
      CardCode: { required, integer, maxLength: maxLength(3) },
    }
  },
  data: () => ({
    card:{
        // ид
        guid: null,
        // Данные принятия предложения сделки
        description: null, 
        // Номер кошелка/счета для возврата средвств
        PayeePurse: null,
        // Владелец карты
        CardHolder: null,
        // Месяц окончания обслуживания карты
        CardMonth: null,
        // Год окончания обслуживаня карты
        CardYear: null,
        // CVC код 
        CardCode: null,
        // Номер телефона для уведомлений по банковскому переводу
        Phone: null,
        // Почтовый адресс для уведомлений по банковскому переводу
        Email: null,
    },
    cards: [

    ],
    id: null,
    isLoad: false,
    isTrue: false
  }),

  mounted () {
    if(this.$route.query.id){
      this.id = this.$route.query.id;
    }
    this.loadData();
    this.loadCard();
  },
  methods: {
    loadData(){
      this.isLoad = true;
      this.$axios.get('auth/me/',{
        }).then(response => {
            if(response.data.result.user)
            {
              this.card.Email = response.data.result.user[0].email;
              this.card.Phone = response.data.result.user[0].phone;
            }
        }).finally(() => {
          this.isLoad = false;
        })

    },
    loadCard(){
      this.isLoad = true;
      this.$axios.get(`auth/me/card`)
      .then(res => {
          if(!res.data.result.IsSuccess){
            notify.warning(res.data.result.Description);
          }
          this.cards = res.data.result.Data;
      }).finally(() => {
          this.isLoad = false;
      });
    },
    send(){
      if(this.card.guid){
        if(this.$v.card.Email.$invalid || this.$v.card.Phone.$invalid){
          return;
        }
      }else{
        this.$v.card.$touch();
        if(this.$v.card.$invalid){
          return;
        }
      }
      this.isLoad = true;
      this.$axios.post(`ticket/${this.id}/pay`, 
      this.card
      ).then(res => {
        if(!res.data.result.IsSuccess){
          notify.warning(res.data.result.Description);
        }else{
          this.isTrue = true;
        }
      }).finally(() => {
        this.isLoad = false;
      });
    }
  },
  watch :{
    getUser(to, from) {
      this.card.Email = to.email;
      this.card.Phone = to.phone;
    },
  },
  computed: {
    ...mapGetters(['getUser']),
    phoneErrors () {
      const errors = []
      if (!this.$v.card.Phone.$dirty) return errors
      !this.$v.card.Phone.integer && errors.push('Только числа')
      !this.$v.card.Phone.maxLength && errors.push('Максимальное количество символов 12')
      !this.$v.card.Phone.required && errors.push('Обязательное поле')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.card.Email.$dirty) return errors
      !this. $v.card.Email.email && errors.push('Неккоректный e-mail')
      !this.$v.card.Email.required && errors.push('Обязательное поле')
      return errors
    },
    payeePurseErrors () {
      const errors = []
      if (!this.$v.card.PayeePurse.$dirty) return errors
      !this.$v.card.PayeePurse.integer && errors.push('Только числа')
      !this.$v.card.PayeePurse.maxLength && errors.push('Максимальное количество символов 16')
      !this.$v.card.PayeePurse.required && errors.push('Обязательное поле')
      return errors
    },
    cardMonthErrors () {
      const errors = []
      if (!this.$v.card.CardMonth.$dirty) return errors
      !this.$v.card.CardMonth.integer && errors.push('Только числа')
      !this.$v.card.CardMonth.maxLength && errors.push('Максимальное количество символов 2')
      !this.$v.card.CardMonth.required && errors.push('Обязательное поле')
      return errors
    },
    cardCodeErrors () {
      const errors = []
      if (!this.$v.card.CardCode.$dirty) return errors
      !this.$v.card.CardCode.integer && errors.push('Только числа')
      !this.$v.card.CardCode.maxLength && errors.push('Максимальное количество символов 3')
      !this.$v.card.CardCode.required && errors.push('Обязательное поле')
      return errors
    },
    cardYearErrors () {
      const errors = []
      if (!this.$v.card.CardYear.$dirty) return errors
      !this.$v.card.CardYear.integer && errors.push('Только числа')
      !this.$v.card.CardYear.maxLength && errors.push('Максимальное количество символов 2')
      !this.$v.card.CardYear.required && errors.push('Обязательное поле')
      return errors
    },
    cardHolderErrors () {
      const errors = []
      if (!this.$v.card.CardHolder.$dirty) return errors
      !this.$v.card.CardHolder.required && errors.push('Обязательное поле')
      return errors
    },
  }
};
</script>

<style scoped>
.card-wrapper{
    background: #F0F0F0;
    border-radius: 14px;
}
  .wrapper-pay{
      height: calc(100vh - 141px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }
  .title-pay{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 36px;
    
  }
  .sucsess{
    color: green;
  }
</style>



// WEBPACK FOOTER //
// pay.vue?6ee3505d